
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 83"}},[_c('path',{attrs:{"data-name":"Path 52","d":"M58.18 8.74A34.72 34.72 0 0048 7.28a27.12 27.12 0 00-16 4.37 27.12 27.12 0 00-16-4.37 27.12 27.12 0 00-16 4.37v42.62a1.55 1.55 0 001.46 1.45c.29 0 .43-.14.72-.14A35.54 35.54 0 0116 52.38a27 27 0 0116 4.36 35 35 0 0116-4.36 29.64 29.64 0 0113.82 3 1.29 1.29 0 00.72.15A1.56 1.56 0 0064 54.12V11.65a19.86 19.86 0 00-5.82-2.91zm0 39.27A33.74 33.74 0 0048 46.56a35 35 0 00-16 4.36V17.47a35 35 0 0116-4.37 33.75 33.75 0 0110.18 1.46z"}}),_c('g',{attrs:{"data-name":"Group 82"}},[_c('path',{attrs:{"data-name":"Path 53","d":"M48 24.74a33.56 33.56 0 017.27.76v-4.43a39.35 39.35 0 00-7.27-.69 33.53 33.53 0 00-13.09 2.41v4.83A27 27 0 0148 24.74z"}}),_c('path',{attrs:{"data-name":"Path 54","d":"M34.91 30.53v4.83A26.88 26.88 0 0148 32.48a34.18 34.18 0 017.27.75v-4.42a39.36 39.36 0 00-7.27-.7 34.09 34.09 0 00-13.09 2.42z"}}),_c('path',{attrs:{"data-name":"Path 55","d":"M48 35.88a33.36 33.36 0 00-13.09 2.42v4.82A27.1 27.1 0 0148 40.24a34.19 34.19 0 017.27.76v-4.42a36.19 36.19 0 00-7.27-.7z"}})])])])
          )
        }
      }
    